import React, { useEffect, useState, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { sideBarHandler } from 'src/store/sideBar/actions'
import { Link } from "react-router-dom";

import { CSidebar, CSidebarBrand, CSidebarNav, CSidebarToggler } from '@coreui/react'

import { AppSidebarNav } from './AppSidebarNav'
import logo from '../assets/images/intrucept-dark-logo.png'
import lightLogo from '../assets/images/Intrucept_logo_hybrid.png'

import strategy from '../assets/images/strategy.png'
import tactical from '../assets/images/tactical.png'
import ops from '../assets/images/ops.png'


import {
  CContainer,
  CHeader,
  CHeaderBrand,
  CHeaderDivider,
  CHeaderNav,
  CHeaderToggler,
  CNavLink,
  CNavItem,
} from '@coreui/react'

import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'
import './style.css'
import { AiFillDashboard } from "react-icons/ai";
import { MdOutlineApps } from "react-icons/md";
import { AiOutlineSecurityScan } from "react-icons/ai";
import { MdIntegrationInstructions } from "react-icons/md";
import { SlOrganization } from "react-icons/sl";
import { SiHelpdesk } from "react-icons/si";
import { SiBookstack } from "react-icons/si";

import { useLocation } from 'react-router-dom'

// sidebar nav config
import { _nav1, _nav2, _nav3 } from '../_nav';


const AppSidebar = (props) => {

  const dispatch = useDispatch();
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidbarReducer.sidebarShow)
  const sideBarSpec = useSelector((state) => state.loginInfo.loginInfo.user?.roles);
  const [user, setUser] = useState(null);
  const [isActiveRoute, setIsActiveRoute] = useState(false);
  const [currentRoute, setCurrentRoute] = useState('/strategic-view');

  const location = useLocation();

  const localData = JSON.parse(localStorage.getItem("user"));

  const authUser = sideBarSpec || localData?.user.userType;

  const handleSidebar = (e) => {
    //console.log('comes to handle sidebar')
    // dispatch(sideBarHandler(!e))
  }

  useEffect(() => {

    setCurrentRoute(location.pathname);
    getUserDetails();

  }, [])

  const highLightMenu = (theRoute) => {

    setCurrentRoute(theRoute);
  }


  const getUserDetails = () => {

    setUser(JSON.parse(localStorage.getItem('ASIUser')));
  }

  return (

    <CSidebar style={{ background: "#252b3b", color: "#000000", width: '15%' ,  marginTop: 70,}}
      position="fixed"
      unfoldable={unfoldable}
      visible={true}
      onVisibleChange={(visible) => {
        handleSidebar(!visible)
      }}
    >
      

      <CSidebarNav>

        <CContainer fluid >

          {user && user.userType == 'user' &&

            <div style={{
              width: '100%', marginLeft: '0%', display: 'flex',
              flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start'
            }}>

              <Link to="/strategic-view" onClick={() => highLightMenu('/strategic-view')}

                className="menuLink"
                style={{
                  padding: 15, display: 'flex', flexDirection: 'row', textDecoration: 'none',
                  background: currentRoute == '/strategic-view' ? '#89181b' : '#252B3B', justifyContent: 'flex-start'
                }}>

                <img src={strategy} style={{width:22}}/>

                <span className="headerText"
                  style={{
                    marginLeft: 10,
                    color: currentRoute == '/strategic-view' ? '#fff' : '#fff'
                  }}>
                  Strategic View</span>
              </Link>


              <Link to="/tactical-view" onClick={() => highLightMenu('/tactical-view')}

                className="menuLink"
                style={{
                  padding: 15, display: 'flex', flexDirection: 'row', textDecoration: 'none',
                  background: currentRoute == '/tactical-view' ? '#89181b' : '#252B3B', justifyContent: 'flex-start'
                }}>


                <img src={tactical} style={{width:22}}/>

                <span className="headerText" style={{ marginLeft: 10, color: currentRoute == '/tactical-view' ? '#fff' : '#fff' }}>
                  Tactical View</span>
              </Link>


              <Link to="/ops-view" onClick={() => highLightMenu('/ops-view')}

                className="menuLink"
                style={{
                  padding: 15, display: 'flex', flexDirection: 'row', textDecoration: 'none',
                  background: currentRoute == '/ops-view' ? '#89181b' : '#252B3B', justifyContent: 'flex-start'
                }}>


                <img src={ops} style={{width:22}}/>

                <span className="headerText" style={{
                  marginLeft: 10,
                  color: currentRoute == '/ops-view' ? '#fff' : '#fff'
                }}>
                  Ops View</span>
              </Link>


              <Link to="/csat" onClick={() => highLightMenu('/csat')}

                className="menuLink"
                style={{
                  padding: 15, display: 'flex', flexDirection: 'row', 
                  textDecoration: 'none',
                  background: currentRoute.includes('csat') ? '#89181b' : '#252B3B', 
                  justifyContent: 'flex-start'
                }}>

                <AiFillDashboard size={22} 
                    color={currentRoute.includes('csat')  ? '#fff' : '#fff'} />


                <span className="headerText" style={{
                  marginLeft: 10,
                  color: currentRoute.includes('csat')  ? '#fff' : '#fff'
                }}>
                  CIS Controls</span>
              </Link>


              <Link to="/risk-register" onClick={() => highLightMenu('/risk-register')}

                className="menuLink"
                style={{
                  padding: 15, display: 'flex', flexDirection: 'row', 
                  textDecoration: 'none',
                  background: currentRoute.includes('risk-register') ? '#89181b' : '#252B3B', 
                  justifyContent: 'flex-start'
                }}>

                <SiBookstack size={22} 
                    color={currentRoute.includes('risk-register')  ? '#fff' : '#fff'} />


                <span className="headerText" style={{
                  marginLeft: 10,
                  color: currentRoute.includes('risk-register')  ? '#fff' : '#fff'
                }}>
                  Risk Register</span>
              </Link>


              <Link to="/tickets" onClick={() => highLightMenu('/tickets')}
                className="menuLink"
                style={{
                  padding: 15, display: 'flex', flexDirection: 'row', textDecoration: 'none',
                  background: (currentRoute.includes('ticket')) ? '#89181b' : '#252B3B', justifyContent: 'flex-start'
                }}>

                <SiHelpdesk size={22} color={currentRoute == '/tickets' ? '#fff' : '#fff'} />
                <span className="headerText"
                style={{ marginLeft: 10, color: currentRoute == '/tickets' ? '#fff' : '#fff' }}>Tickets</span>
              </Link>

              <Link to="/connectors" onClick={() => highLightMenu('/connectors')}
                className="menuLink"
                style={{
                  padding: 15, display: 'flex', flexDirection: 'row', textDecoration: 'none',
                  background: currentRoute == '/connectors' ? '#89181b' : '#252B3B', justifyContent: 'flex-start'
                }}>

                <MdIntegrationInstructions size={22} color={currentRoute == '/connectors' ? '#fff' : '#fff'} />
                <span className="headerText"
                style={{ marginLeft: 10, color: currentRoute == '/connectors' ? '#fff' : '#fff' }}>Connectors</span>
              </Link>

              <Link to="/organization" onClick={() => highLightMenu('/organization')}
                className="menuLink"
                style={{
                  padding: 15, display: 'flex', flexDirection: 'row', textDecoration: 'none',
                  background: (currentRoute == '/organization'
                    || currentRoute.includes('users') || currentRoute.includes('add-user') || currentRoute.includes('edit-user')
                    || currentRoute.includes('business-unit')
                    || currentRoute.includes('asset-group')
                  ) ? '#89181b' : '#252B3B', justifyContent: 'flex-start'
                }}>

                <SlOrganization size={22}
                  color={currentRoute == '/organization' ? '#fff' : '#fff'} />
                <span className="headerText" style={{
                  marginLeft: 10,
                  color: currentRoute == '/organization' ? '#fff' : '#fff'
                }}>Organization</span>
              </Link>


              <Link to="/users" onClick={() => highLightMenu('/users')}
                className="menuLink"
                style={{
                  padding: 5, display: 'flex', flexDirection: 'row', textDecoration: 'none', marginTop: 10,
                  justifyContent: 'flex-start'
                }}>

                <text className="headerText" style={{
                  marginLeft: 40, fontSize: 14, color:
                    (currentRoute.includes('users') || currentRoute.includes('add-user') || currentRoute.includes('edit-user')) ? '#fff' : '#fff'
                }}>
                  Users</text>
              </Link>

              <Link to="/business-units" onClick={() => highLightMenu('/business-units')}
                className="menuLink"
                style={{
                  padding: 5, display: 'flex', flexDirection: 'row', textDecoration: 'none',
                  justifyContent: 'flex-start'
                }}>

                <text className="headerText" style={{
                  marginLeft: 40, fontSize: 14, color:
                    (currentRoute.includes('business-unit')) ? '#fff' : '#fff'
                }}>
                  Business Units</text>
              </Link>

              <Link to="/asset-groups" onClick={() => highLightMenu('/asset-groups')}
                className="menuLink"
                style={{
                  padding: 5, display: 'flex', flexDirection: 'row', textDecoration: 'none',
                  justifyContent: 'flex-start'
                }}>

                <text className="headerText" style={{
                  marginLeft: 40, fontSize: 14, color:
                    (currentRoute.includes('asset-group') ? '#fff' : '#fff')
                }}>
                  Asset Groups</text>
              </Link>

            </div>
          }

        </CContainer>

      </CSidebarNav>
      <CSidebarToggler
        className="d-none d-lg-flex"
        onClick={() => { handleSidebar(!unfoldable) }}
      />
    </CSidebar>
  )
}

export default React.memo(AppSidebar)